export default {
  settingStatementBase: {
    title: 'Basic settings',
    name: 'Channel name',
    onOff: 'On/Off',
    operationRecord: 'Operation records',
    field: 'Field maintenance',
    shop: 'Store maintenance for reconciliation',
    operator: 'Operator',
    tableContent: 'Enable channel',
    tableLogName: 'Big Brother',
    addField: 'Add field',
    fieldName: 'Field name',
    sort: 'Sort',
    revise: 'Modify',
    tableFieldName: 'Account transaction number',
    storeName: 'Store name',
    storeCode: 'Store code',
    storeText: 'No store found for reconciliation settings',
    storeAddText: 'Go to add store',
    tableShopName: 'Tmall_Jiumu Official Flagship Store_Distribution_2000',
  },
};
